// removed by extract-text-webpack-plugin
module.exports = {"base":"CardImage_base--1Gp5J","base__elite":"CardImage_base__elite--csXK5","baseElite":"CardImage_base__elite--csXK5","notEnoughLevel":"CardImage_notEnoughLevel--aiFHn","necessaryLevel":"CardImage_necessaryLevel--1677S","levelIllustration":"CardImage_levelIllustration--FyD4p","buildingsLevel":"CardImage_buildingsLevel--24slk","levelLacks":"CardImage_levelLacks--1cdiD","maxLevelMessage":"CardImage_maxLevelMessage--3Jrcv"};


//////////////////
// WEBPACK FOOTER
// ./containers/CommandCenterCard/components/CardImage/CardImage.scss
// module id = 2137
// module chunks = 11